<script>
    import _ from 'lodash';
    import moment from 'moment';
    import {Link} from 'svelte-routing';
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import BottomMenu from '../components/BottomMenu.svelte';
    import TaskCalendar from '../components/TaskCalendar.svelte';


    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    const fetchOrderList = async () => {
        let list = await network.getOrderList(+$user.id, +$user.idkontr, +$user.idSklad),
            chat = await network.getChatMessagesCount(_.map(list, 'nomer'), +$user.id);

        return list.map((item) => {
            let buf;

            if ((buf = chat.find(el => item.nomer === el.order)) !== null && buf && buf.count) {
                item.chat = buf.count;
            } else {
                item.chat = 0;
            }

            return item;
        });
    }
    let search = '',
        orders = fetchOrderList();

    let viewMode = 'list'; // 'list' | 'calendar'
    let calendarMonth = new Date();

    function setViewMode(mode) {
        viewMode = mode;
    }

    const fetchOrderListForRange = async (from, to) => {
        let list = await network.getOrderListRange(+$user.id, +$user.idkontr, +$user.idSklad, from, to);
        let chat = await network.getChatMessagesCount(list.map(item => item.nomer), +$user.id);
        return list.map(item => {
            let buf = chat.find(el => el.order === item.nomer && el.order != null);
            item.chat = buf ? buf.count : 0;
            return item;
        });
    };

    function monthRangeStr(date) {
        const from = moment(date).startOf('month').format('YYYY-MM-DD');
        const to = moment(date).endOf('month').add(1, 'day').format('YYYY-MM-DD');
        return { from, to };
    }

    let calendarOrders = fetchOrderListForRange(...Object.values(monthRangeStr(calendarMonth)));

    function onCalendarMonthChange(event) {
        calendarMonth = event.detail.month;
        const { from, to } = monthRangeStr(calendarMonth);
        calendarOrders = fetchOrderListForRange(from, to);
    }

    const filter = _.debounce(async () => {
        let data = await fetchOrderList();

        if (search.trim()) {
            return orders = data.filter((item) => {
                return (
                    item.name.indexOf(search) !== -1 ||
                    item.komment.indexOf(search) !== -1
                )
            });
        }

        orders = data;
    }, 1000);


    const STATUSES = [
        { vid: '16', label: 'Новые', color: '#42a5f5' , colort: '#fff' },
        { vid: '21', label: 'В работе', color: '#66bb6a', colort: '#fff'  },
        { vid: '22', label: 'Выполненные', color: '#d4e157', colort: '#000'  },

    ];




    const STATUS_FILTER_STORAGE_KEY = 'dashboard_status_filter';
    const DEFAULT_STATUSES = ['16', '21', '22'];

    function loadSavedStatuses() {
        try {
            const raw = localStorage.getItem(STATUS_FILTER_STORAGE_KEY);
            if (raw === null) return DEFAULT_STATUSES;
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : DEFAULT_STATUSES;
        } catch (e) {
            return DEFAULT_STATUSES;
        }
    }

    function saveStatuses(statuses) {
        try {
            localStorage.setItem(STATUS_FILTER_STORAGE_KEY, JSON.stringify(statuses));
        } catch (e) {
            // localStorage может быть недоступен (приватный режим) — просто игнорируем
        }
    }

    let selectedStatuses = loadSavedStatuses();

    function toggleStatus(vid) {
        if (vid === 'all') {
            selectedStatuses = [];
        } else if (selectedStatuses.includes(vid)) {
            selectedStatuses = selectedStatuses.filter(v => v !== vid);
        } else {
            selectedStatuses = [...selectedStatuses, vid];
        }
        saveStatuses(selectedStatuses);
    }

    function applyStatusFilter(list) {
        if (!selectedStatuses.length) return list;
        return list.filter(item => selectedStatuses.includes(String(item.vid)));
    }


    let resolvedList = [];
    let ordersLoading = true;

    $: orders.then(data => {
        resolvedList = data;
        ordersLoading = false;
    });

    $: filteredList = selectedStatuses.length
        ? resolvedList.filter(item => selectedStatuses.includes(String(item.vid)))
        : resolvedList;



    let resolvedCalendarList = [];
    let calendarLoading = true;

    $: calendarOrders.then(data => {
        resolvedCalendarList = data;
        calendarLoading = false;
    });

    $: filteredCalendarList = selectedStatuses.length
        ? resolvedCalendarList.filter(item => selectedStatuses.includes(String(item.vid)))
        : resolvedCalendarList;


    // --- Логика модального окна логгера ---
    let loggerModalOpen = false;
    let loggerModalUrl = '';

    function openLoggerModal(nomer) {
        loggerModalUrl = `https://logger.trademaster.pro/${nomer}?storage=stratagema&user_id=${$user.id}&user_name=${$user.name}`;
        loggerModalOpen = true;
    }

    function closeLoggerModal() {
        loggerModalOpen = false;
        loggerModalUrl = '';
    }

    function handleKeydown(e) {
        if (e.key === 'Escape' && loggerModalOpen) closeLoggerModal();
    }

    // Карта статусов для убирания избыточного 'if-else' из разметки
    const STATUS_MAP = {
        '16': { label: 'Новая', class: 'chip-new' },
        '17': { label: 'Получение данных', class: 'chip-primary' },
        '18': { label: 'В оценке', class: 'chip-success' },
        '19': { label: 'В согласовании', class: 'chip-danger' },
        '20': { label: 'Ожидание информации', class: 'chip-info' },
        '21': { label: 'В работе', class: 'chip-warning' },
        '22': { label: 'Выполнено', class: 'chip-success' },
        '23': { label: 'Передано', class: 'chip-primary' },
        '24': { label: 'Завершено', class: 'chip-success' },
    };
</script>

<svelte:window on:keydown={handleKeydown} />

<TopMenu title="Мои задачи" />

<div class="extraHeader dashboard-header  ">
    <form  >
        <div class="form-group searchbox">
            <input type="text" class="form-control" placeholder="Поиск..." bind:value={search} on:keyup={filter}>
            <i class="input-icon">
                <ion-icon name="search-outline" role="img" class="md hydrated" aria-label="search outline"></ion-icon>
            </i>
        </div>
    </form>

    <div class="status-filter">
        <button
                class="status-chip {selectedStatuses.length === 0 ? 'active' : ''}"
                on:click={() => toggleStatus('all')}
        >
            Все
        </button>
        {#each STATUSES as s}
            <button
                    class="status-chip {selectedStatuses.includes(s.vid) ? 'active' : ''}"
                    style="--chip-color: {s.color}; {selectedStatuses.includes(s.vid) ? `color: ${s.colort};` : ''}"
                    on:click={() => toggleStatus(s.vid)}
            >
                {s.label}
            </button>
        {/each}
    </div>

    <div class="view-toggle">
        <button class="toggle-btn {viewMode === 'list' ? 'active' : ''} px-3" on:click={() => setViewMode('list')}>
            Список
        </button>
        <button class="toggle-btn {viewMode === 'calendar' ? 'active' : ''} px-3" on:click={() => setViewMode('calendar')}>
            Календарь
        </button>
    </div>
</div>

<div id="appCapsule" class="extra-header-active">
    {#if ordersLoading}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем список ваших задач.
                    </p>
                </div>
            </div>
        </div>
    {:else if viewMode === 'list'}
        <div class="section full">
            <div class="bg-white">
                <ul class="listview link-listview">
                    {#each filteredList as item (item.nomer)}
                        <li>
                            <div class="row px-3 py-3 align-items-center">

                                <!-- Левая колонка: Основная информация -->
                                <div class="col-12 col-md-6">
                                    <div class="d-flex align-items-center gap-2 mb-1">
                                        <Link to="/order/{item.nomer}/{item.vid}" class="text-decoration-none fw-bold d-inline-flex align-items-center gap-1 order-link">
                                            <h4 class="d-inline mb-0">{item.nomer} {item.tipIzd}</h4>
                                            <ion-icon name="open-outline" class="order-link-icon"></ion-icon>
                                        </Link>
                                        <small class="text-muted ms-1">{moment(item.data).format('DD.MM.YYYY')}</small>
                                    </div>

                                    {#if item.tovarName}
                                        <div class="fw-medium text-dark">{item.tovarName}</div>
                                    {/if}

                                    {#if item.komment}
                                        <div class="text-secondary small">{item.komment}</div>
                                    {/if}
                                </div>

                                <!-- Правая колонка: Чаты, Статусы, Оплата -->
                                <div class="col-12 col-md-6 text-end text-md- mt-2 mt-md-0">
                                    <!-- Верхняя линия: Чат и Статус -->
                                    <div class="d-inline-flex flex-wrap gap-1 align-items-center mb-2 justify-content-start justify-content-md-end">
                                        <div class="chip chip-media">
                                            <button
                                                    type="button"
                                                    class="chip-link-btn"
                                                    on:click={() => openLoggerModal(item.nomer)}
                                            >
                                                <i class="chip-icon bg-dark">
                                                    <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                                                </i>
                                                <span class="chip-label text-black">
                                            {item.chat || '—'}
                                        </span>
                                            </button>
                                        </div>

                                        {#if STATUS_MAP[item.vid]}
                                            <div class="chip {STATUS_MAP[item.vid].class}">
                                                <span class="chip-label">{STATUS_MAP[item.vid].label}</span>
                                            </div>
                                        {/if}
                                    </div>

                                    <!-- Нижняя линия: Финансы -->
                                    {#if +item.summa || +item.summaOpl}
                                        <div class="d-flex gap-1 justify-content-start justify-content-md-end">
                                            {#if +item.summa}
                                                <div class="chip chip-media">
                                                    <i class="chip-icon bg-primary">
                                                        <ion-icon name="cash-outline"></ion-icon>
                                                    </i>
                                                    <span class="chip-label">{(+item.summa).toFixed(0)} ₽</span>
                                                </div>
                                            {/if}

                                            {#if +item.summaOpl}
                                                <div class="chip chip-media">
                                                    <i class="chip-icon bg-success">
                                                        <ion-icon name="cash-outline"></ion-icon>
                                                    </i>
                                                    <span class="chip-label">{(+item.summaOpl).toFixed(0)} ₽</span>
                                                </div>
                                            {/if}
                                        </div>
                                    {/if}
                                </div>

                            </div>
                        </li>
                    {/each}
                </ul>

                {#if filteredList.length === 0}
                    <div class="empty-filter-state p-4 text-center text-muted">
                        <p class="mb-0">Нет задач с выбранным статусом</p>
                    </div>
                {/if}
            </div>
        </div>
    {:else}
        {#if calendarLoading}
            <div class="section mt-2">
                <div class="card text-center">
                    <div class="card-body p-5">
                        <p class="card-text">Загрузка календаря...</p>
                    </div>
                </div>
            </div>
        {:else}
            <TaskCalendar tasks={filteredCalendarList} bind:currentMonth={calendarMonth} on:monthChange={onCalendarMonthChange} />
        {/if}
    {/if}
</div>

{#if loggerModalOpen}
    <div class="logger-modal-overlay" on:click={closeLoggerModal}>
        <div class="logger-modal-window" on:click|stopPropagation>
            <button class="logger-modal-close" on:click={closeLoggerModal} aria-label="Закрыть">
                <ion-icon name="close-outline"></ion-icon>
            </button>
            <iframe
                    src={loggerModalUrl}
                    class="logger-modal-iframe"
                    title="Логгер задачи"
                    allow="clipboard-write"
            ></iframe>
        </div>
    </div>
{/if}

<BottomMenu />


<style>
    .view-toggle {
        display: flex;
        gap: 4px;
        padding: 4px;

        background: #f1f3f5;
        border-radius: 14px;
    }

    .toggle-btn {
        flex: 1;
        padding: 9px 0;
        border: none;
        border-radius: 10px;
        background: transparent;
        font-size: 13px;
        font-weight: 600;
        color: #6b7280;
        cursor: pointer;
        transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
        -webkit-tap-highlight-color: transparent;
    }

    .toggle-btn:active {
        transform: scale(0.97);
    }

    .toggle-btn.active {
        background: #ffffff;
        color: #0b7285;
        box-shadow: 0 2px 6px rgba(11, 114, 133, 0.14);
    }

    .status-filter {
        display: flex;
        flex-wrap: nowrap;
        gap: 6px;
        padding: 10px 10px 10px 10px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .status-filter::-webkit-scrollbar {
        display: none;
    }

    .status-chip {
        flex: 0 0 auto;
        padding: 6px 12px;
        border-radius: 999px;
        border: 1.5px solid #d8dde3;
        background: #fff;
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.15s ease;
        -webkit-tap-highlight-color: transparent;
    }

    .status-chip:active {
        transform: scale(0.96);
    }

    .status-chip.active {
        background: var(--chip-color, #0b7285);
        border-color: var(--chip-color, #0b7285);
        color: #fff;
    }

    .empty-filter-state {
        text-align: center;
        padding: 40px 20px;
        color: #9ca3af;
        font-size: 14px;
    }

    .chip-new {
        background: #42a5f5!important;
    }
    .chip-warning {
        background: #66bb6a!important;
    }
    .chip-success {
        background: #d4e157!important;
        color: #0c1624!important;
    }

    .dashboard-header {
        display: flex!important;
        justify-content: space-between;
        flex-direction: row;

    }
    .extraHeader{
        height: auto;
    }

    @media (max-width: 880px) {
        .dashboard-header {
            display: flex!important;
            flex-direction: column!important;

        }

        #appCapsule {
            padding: 215px 0!important;
        }
    }

    /* --- Модальное окно логгера --- */
    .chip-link-btn {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
    }

    .logger-modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logger-modal-window {
        position: relative;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);

        width: 90vw;
        max-width: 900px;
        height: 80vh;
    }

    .logger-modal-close {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 10;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }

    .logger-modal-iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }

    @media (max-width: 880px) {
        .logger-modal-overlay {
            padding: 0;
        }

        .logger-modal-window {
            width: 100vw;
            max-width: 100vw;
            height: 100vh;
            border-radius: 0;
        }

        .logger-modal-close {
            top: 12px;
            right: 12px;
        }
    }
</style>
